import React from "react";

const Input = ({
  label,
  type = "text",
  id,
  name,
  placeholder,
  required = false,
  disabled = false,
  error,
  errorId,
  ...props
}) => {
  const hasError = !!error;

  return (
    <div>
      {label && (
        <label
          htmlFor={id}
          className="block text-[13px] leading-[18px] text-[#323539] font-bold mb-2"
        >
          {label}
        </label>
      )}
      <input
        type={type}
        id={id}
        name={name}
        placeholder={placeholder}
        required={required}
        disabled={disabled}
        className={`shadow appearance-none border-[#E5E5E7] border rounded-[128px] w-full py-[14px] px-4 text-[15px] leading-[22px] text-black focus:outline-none focus:shadow-outline ${
          hasError ? "border-[#EF4444]" : ""
        }`}
        {...props}
      />
      {hasError && (
        <p className="text-lg text-[#EF4444] mt-2" id={errorId ? errorId : ""}>
          {error}
        </p>
      )}
    </div>
  );
};

export default Input;
